import React from 'react';
import { connect } from 'react-redux';
import { CardPicker } from '@americanexpress/aqx-components';
import useCardSelectorItemClickDtm from 'src/universal/hooks/useCardSelectorItemClickDtm';
import { buildCompareCtaDtm } from 'src/universal/utils/cardSelectorHelper';

import {
  getFilteredSelectedCards,
  dispatchAddCardsToCompare,
  getCardSelectorData
} from 'src/universal/redux/compareCardsTray';
import { getCardSelectorCards } from 'page_modules/compare/redux';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';

import styles from 'page_modules/compare/__styles__/cardSelector.scss?modules';

const CardSelector = ({
  selectorData,
  addCards,
  categoriesOfCards,
  selectedCards,
  toggle
}) => {
  useCardSelectorItemClickDtm(
    styles.cardSelector,
    selectorData?.cardItemDtm,
    categoriesOfCards
  );
  return (
    <div className={styles.cardSelector}>
      <CardPicker
        selectedCards={selectedCards}
        title={selectorData?.title}
        backButtonText={selectorData?.ctaBackText}
        compareButtonText={selectorData.ctaCompareText}
        backButtonOnClick={() => {
          sendDTMClickEvent(selectorData?.ctaBackDtm);
          toggle();
        }}
        compareOnClick={shortNames => {
          addCards(shortNames);
          const dtmObj = buildCompareCtaDtm(
            shortNames,
            selectorData?.ctaCompareDtm,
            categoriesOfCards
          );
          sendDTMClickEvent(dtmObj);
          toggle();
        }}
        categoriesOfCards={categoriesOfCards}
      />
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  addCards: shortNames => dispatchAddCardsToCompare(dispatch, { shortNames })
});
const mapStateToProps = state => ({
  selectedCards: getFilteredSelectedCards(state),
  categoriesOfCards: getCardSelectorCards(state),
  selectorData: getCardSelectorData(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardSelector);
